/***********************************************************
/*   
/*    Customization
/*
/************************************************************/

var $ = jQuery.noConflict();

// Dropdown Menu Fade    
jQuery(document).ready(function(){

	var qs=window.location.search;
   	var hash=getUrlParameter(qs,'hash');
   	var start=getUrlParameter(qs,'s');
   	var raw=getUrlParameter(qs,'raw');
   	var noclose=getUrlParameter(qs,'noclose');
	//var noheader=getUrlParameter(qs,'noheader');
	console.log(start);

	if (raw === 'yes') {
		$('.widget-header, .powered_by').hide().remove();
		$('.powered_by').hide();
	}
	else if (noclose == 'yes' || noclose == 'true') {
		$('.widget-header .header_close').hide();
	}
	
	//if (noheader == 'true')
		//$('.widget-header').hide().remove();


	function customize_widget() {	

		 _CUSTOM_URL=(_URL) ? _URL + "/app/embed/custom.php?hash="+hash : null;

        if (_CUSTOM_URL) {

	 		$.ajax({
            	type: "POST",
            	url: _CUSTOM_URL,
            	timeout: 3000,
            	success: function(data) {
                	var settings = $.parseJSON(data);
					console.log(settings);
					var header_title = (settings.brand_widget_title) ? settings.brand_widget_title : "Chat with Casey";
	
					$('.header_title').html(header_title);

					// if custom language for click-to-call, set html and data-text on those fields
					// instruction message
					if (settings.global && settings.global.click_to_call_settings && settings.global.click_to_call_settings.instruction_text) {
						$(".text:nth-of-type(2)", ".click-call-controls").html(settings.global.click_to_call_settings.instruction_text);
						$(".text:nth-of-type(2)", ".click-call-controls").data("text", settings.global.click_to_call_settings.instruction_text);
					}
					// unavailable message
					if (settings.global && settings.global.click_to_call_settings && settings.global.click_to_call_settings.unavailable_text) {
						$(".text:nth-of-type(2)", ".click-call-unavailable").html(settings.global.click_to_call_settings.unavailable_text);
						$(".text:nth-of-type(2)", ".click-call-unavailable").data("text", settings.global.click_to_call_settings.unavailable_text);
					}
	
            	},
            	error: function(xhr,status,error) {
                	var errorMessage = xhr.status + ': ' + xhr.statusText + 'https://simplyconvert.com/app/embed/custom.php';
                	console.log(errorMessage);
            	}
			});
		}
	}
	
	try {
		customize_widget();
	}
	catch(err) {
		console.log("error in custom_widget");
		console.log(err);
	}

});

$(document).ready(function(){
	$(document).on('keyup', '#selectControlID', function(e){
		var searchTerm = $(this).val().toLowerCase();
		$('.select-options').removeClass('selected-option');
		$(this).trigger('change');
		if(e.key == "Enter"){
			//if key was enter get top li
			e.preventDefault();
			var found = false;
			$(this).prev('.option-list').children('.select-options').each(function() {
				if ($(this).css('display') !== 'none' && !found) {
					var selectInput = $(this).parent().next('#selectControlID');
					var value = $(this).data('display');
					$('.select-options').removeClass('selected-option');
					$(this).addClass('selected-option');
					$(selectInput).val(value);
					$(selectInput).blur();
					$(selectInput).trigger('change');
					$('.option-list').css('display', 'none');
					found = true;
				}
			});
		}
		else{
			$(".select-options").each(function() {
				if ($(this).text().toLowerCase().indexOf(searchTerm) === -1) {
					$(this).hide();
				} else {
					$(this).show();
				}
			});
		}
	});
	$(document).on('click', ".select-options", function(){
		var selectInput = $(this).parent().next('#selectControlID');
		var value = $(this).data('display');
		$('.select-options').removeClass('selected-option');
		$(this).addClass('selected-option');
		$(selectInput).val(value);
		$(selectInput).blur();
		$(selectInput).trigger('change');
		$('.option-list').css('display', 'none');
	});
	$(document).on('focus', '#selectControlID', function(){
		$('.option-list').css('display', 'block');
		$(this).trigger('keyup');
	});
	
});
$(document).ready(function(){
	$("#video-control-icon").on('click' ,function() {
		if($("#video-control-icon").hasClass('closed-icon')){
			$('#video-control-icon').addClass('open-icon');
			$('#video-control-icon').removeClass('closed-icon');
		}
		else{
			$('#video-control-icon').removeClass('open-icon');
			$('#video-control-icon').addClass('closed-icon');
			$('mux-player').trigger('pause');
		}
		$("#videoCollapse").slideToggle(500);
		//$("#videoCollapse").fadeToggle(500);
	});
	
});
$(document).ready(function(){
	var qs=window.location.search;
   	var theme=getUrlParameter(qs,'theme');
	if(theme == 'modern'){
		$("#videoCollapse").css('margin-top', '80px');
	}
});
